import React, { Component } from 'react'
import './index.scss'
import { Header, Menu, Footer } from '../../'

import productDetailOne from '../../../assets/images/product/product_detail_01.jpg'
import productDetailTwo from '../../../assets/images/product/product_detail_02.jpg'
import productDetailThree from '../../../assets/images/product/product_detail_03.jpg'

import productOne from '../../../assets/images/product/product_01.jpg'
import productTwo from '../../../assets/images/product/product_02.jpg'
import productThree from '../../../assets/images/product/product_03.jpg'

import productFour from '../../../assets/images/product/product_04.jpg'
import productFive from '../../../assets/images/product/product_05.jpg'
import productSix from '../../../assets/images/product/product_06.jpg'
import productSeven from '../../../assets/images/product/product_07.jpg'

import productEight from '../../../assets/images/product/product_08.jpg'
import productNine from '../../../assets/images/product/product_09.jpg'
import productTen from '../../../assets/images/product/product_10.jpg'
import productEleven from '../../../assets/images/product/product_11.jpg'
import productTwelve from '../../../assets/images/product/product_12.jpg'
import productThirtheen from '../../../assets/images/product/product_13.jpg'
import productFourteen from '../../../assets/images/product/product_14.jpg'
import productFifteen from '../../../assets/images/product/product_15.jpg'
import productSixteen from '../../../assets/images/product/product_16.jpg'
import productSeventeen from '../../../assets/images/product/product_17.jpg'
import productEighteen from '../../../assets/images/product/product_18.jpg'
import productNineteen from '../../../assets/images/product/product_19.jpg'

import productTwenty from '../../../assets/images/product/product_20.png'
import productTwentyOne from '../../../assets/images/product/product_21.png'
import productTwentyTwo from '../../../assets/images/product/product_22.png'
import productTwentyThree from '../../../assets/images/product/product_23.png'
import productTwentyFour from '../../../assets/images/product/product_24.png'

class ProductDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productListOne: [
        {
          title: 'ไส้อั่วจิ๋ว',
          detail: 'กลิ่นหอม ชวนรับประทาน สัมผัสได้ถึงรสชาติพริกแกง และเครื่องเทศ',
          src: productOne
        },
        {
          title: 'ไส้กรอกอีสานจิ๋ว',
          detail: 'เด่นด้านรสชาติที่ลงตัว รับประทานง่าย อร่อยเพลิน',
          src: productTwo
        },
        {
          title: 'ไส้กรอกวุ้นเส้นจิ๋ว',
          detail: 'รสชาติกลมกล่อม เปรี้ยวกำลังดี หอมกำลังโดน',
          src: productThree
        }
      ],
      productListTwo: [
        {
          title: 'ไส้อั่วกระดุม',
          src: productFour
        },
        {
          title: 'ไส้กรอกหมูกระเทียมกระดุม',
          src: productFive
        },
        {
          title: 'ไส้กรอกอีสานกระดุม',
          src: productSix
        },
        {
          title: 'ไส้กรอกวุ้นเส้นกระดุม',
          src: productSeven
        }
      ],
      productListThree: [
        {
          title: 'ไส้อั่ว',
          src: productEight
        },
        {
          title: 'ไส้กรอกอีสาน',
          src: productNine
        },
        {
          title: 'ไส้กรอกวุ้นเส้น',
          src: productTen
        },
        {
          title: 'ไส้กรอกหมูกระเทียม',
          src: productEleven
        },
        {
          title: 'ไส้กรอกกระเพรา',
          src: productTwelve
        },
        {
          title: 'ไส้กรอกรมควัน',
          src: productThirtheen
        }
      ],
      productListFour: [
        {
          title: 'ไส้อั่ว(ถุง)',
          src: productFourteen
        },
        {
          title: 'ไส้กรอกอีสาน(ถุง)',
          src: productFifteen
        },
        {
          title: 'ไส้กรอกวุ้นเส้น(ถุง)',
          src: productSixteen
        },
        {
          title: 'ไส้กรอกหมูกระเทียม(ถุง)',
          src: productSeventeen
        },
        {
          title: 'ไส้กรอกกระเพรา(ถุง)',
          src: productEighteen
        },
        {
          title: 'ไส้กรอกรมควัน(ถุง)',
          src: productNineteen
        }
      ],
      productListFive: [
        {
          title: 'ไส้อั่ว(เพ้งตี๋)',
          src: productTwenty
        },
        {
          title: 'ไส้กรอกอีสาน(เพ้งตี๋)',
          src: productTwentyOne
        },
        {
          title: 'ไส้อั่ว(กลาง)',
          src: productTwentyTwo
        },
        {
          title: 'ไส้กรอกอีสาน(กลาง)',
          src: productTwentyThree
        },
        {
          title: 'ไส้กรอกวุ้นเส้น(กลาง)',
          src: productTwentyFour
        }
      ]
    }
  }
  render() {
    return (
      <>
        <Header />
        <div className="container-lg p-0">
          <Menu />
        </div>
        <div className="ch-product-detail">
          <div className="container-lg">
            <h1 className="display-4 text-center font-weight-bold">
              <span>สินค้า</span>
            </h1>
            <div className="ch-hotsale-product-detail-container">
              <h1>HOT SALE</h1>
              <div className="ch-hotsale-product-detail-wrapper">
                {this.state.productListFive.map((data, i) => {
                  return (
                    <div className="ch-hotsale-product-detail-box" key={i}>
                      <div className="ch-hotsale-product-detail-item">
                        <img className="img-fluid" src={data.src} alt="chefhung-hotsale-product" />
                        <h4>{data.title}</h4>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="ch-product-detail-container">
              <div className="ch-wrapper">
                <div className="ch-paper">
                  <img className="img-fluid" src={productDetailOne} alt="chefhung-new-product" />
                  <h1 className="ch-paper-title">NEW PRODUCT</h1>
                  {this.state.productListOne.map((data, i) => {
                    return (
                      <div className="ch-paper-flex" key={i}>
                        <div className="ch-item">
                          <img className="img-fluid" src={data.src} alt="chefhung-new-product" />
                        </div>
                        <div className="ch-item-detail">
                          <h2>{data.title}</h2>
                          <h5>{data.detail}</h5>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="ch-wrapper">
                <div className="ch-paper">
                  <img
                    className="img-fluid mt-sm"
                    src={productDetailTwo}
                    alt="chefhung-best-product"
                  />
                  <h1 className="ch-paper-title">BEST PRODUCT</h1>
                  <div className="ch-paper-container">
                    {this.state.productListTwo.map((data, i) => {
                      return (
                        <div className="ch-item-box" key={i}>
                          <img className="img-fluid" src={data.src} alt="chefhung-best-product" />
                          <h2>{data.title}</h2>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div class="ch-main-product-detail-container">
              <div className="col-lg-10 offset-lg-1 p-0">
                <div className="ch-paper">
                  <img className="img-fluid" src={productDetailThree} alt="chefhung-main-product" />
                  <h1 className="ch-paper-title">MAIN PRODUCT</h1>
                </div>
              </div>
              <div className="col-lg-10 offset-lg-1">
                <div className="ch-main-product-box">
                  <div className="ch-main-product-img">
                    {this.state.productListThree.map((data, i) => {
                      return (
                        <div className="ch-grid-img" key={i}>
                          <img className="img-fluid" src={data.src} alt="chefhung-main-product" />
                          <div className="ch-number">{i + 1}</div>
                        </div>
                      )
                    })}
                  </div>
                  <div className="ch-main-product-detail">
                    {this.state.productListThree.map((data, i) => {
                      return (
                        <h4 key={i}>
                          {i + 1}. {data.title}
                        </h4>
                      )
                    })}
                  </div>
                </div>
              </div>
              <div className="col-lg-10 offset-lg-1">
                <div className="ch-main-product-box">
                  <div className="ch-main-product-img">
                    {this.state.productListFour.map((data, i) => {
                      return (
                        <div className="ch-grid-img" key={i}>
                          <img className="img-fluid" src={data.src} alt="chefhung-main-product" />
                          <div className="ch-number">{i + 1}</div>
                        </div>
                      )
                    })}
                  </div>
                  <div className="ch-main-product-detail">
                    {this.state.productListFour.map((data, i) => {
                      return (
                        <h4 key={i}>
                          {i + 1}. {data.title}
                        </h4>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default ProductDetail
